import React from 'react';
import {Field} from 'react-final-form';

const Condition = ({when, is, children, ...props}) =>
  React.Children.map(children, child => (
    <Field name={when} subscription={{value: true}}>
      {({input: {value}}) => {
        if (Array.isArray(value)) {
          return value.some(el => {
            return JSON.stringify(el) === JSON.stringify(is);
          })
            ? React.cloneElement(child, {...props})
            : null;
        }

        let match = false;

        if (Array.isArray(is)) {
          for (const currentValue of is) {
            if (value === currentValue) {
              match = true;
              break;
            }
          }
        } else {
          match = value === is;
        }

        return match ? React.cloneElement(child, {...props}) : null;
      }}
    </Field>
  ));

export default Condition;
